import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Button } from '@mui/material'

import { ApplicationState } from '@/state/root.models'
import { FormStatusType } from '@/enums'

type Props = {
  handleCreateBonusOffer: () => void
  disableSubmit: boolean
}

const NavigationBottomComponent = ({
  handleCreateBonusOffer,
  disableSubmit,
}: Props) => {
  const { t } = useTranslation()

  const { bonusFormMode } = useSelector(
    ({ bonusEngine }: ApplicationState) => bonusEngine,
  )

  return (
    <Button
      variant="contained"
      color="primary"
      className="margin-x"
      size="small"
      onClick={() => handleCreateBonusOffer()}
      disabled={disableSubmit}
    >
      {bonusFormMode === FormStatusType.DUPLICATE
        ? t('labels.duplicate').toUpperCase()
        : t('labels.update').toUpperCase()}
    </Button>
  )
}

export default NavigationBottomComponent
